var Order;
(function (Order) {
    Order["ASC"] = "ascending";
    Order["DESC"] = "descending";
})(Order || (Order = {}));
export default Order;
